
import Vue from "vue";
import Component from "vue-class-component";
import { Model, Prop } from "vue-property-decorator";

@Component
export default class Input extends Vue {
  @Prop({ default: "" }) readonly label!: string;
  @Prop({ default: "" }) readonly error!: string;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: false }) readonly readonly!: boolean;
  @Model("input", { required: true }) value!: string;
}
